import { CountriesInterfaceState, initialCountriesState } from '../state/countries.state';
import { CountriesActions, ECountriesActions } from '../actions/countries.actions';

export function countriesReducer(state: CountriesInterfaceState = initialCountriesState, action: CountriesActions): CountriesInterfaceState {
  switch (action.type) {
    case ECountriesActions.GetCountriesSuccess: {
      return { ...state, list: action.payload };
    }

    default:
      return state;
  }
};
